(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1328],{

/***/ 4100:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice",
      function () {
        return __webpack_require__(3667);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var components_layout_headers_Both__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3496);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5549);
/* harmony import */ var cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5472);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7732);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6643);
/* harmony import */ var cds_layout_Main__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3475);
/* harmony import */ var cds_layout_VerticalScroll__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(498);
/* harmony import */ var components_atoms_common_SpinLoading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5734);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9809);
/* harmony import */ var slices_service_thunk__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7688);
/* harmony import */ var hooks_common_useInfiniteScroll__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8970);
/* harmony import */ var hooks_bridge_useCommonBridge__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5397);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8004);
/* harmony import */ var hooks_common_useMetaData__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6016);
/* harmony import */ var lib_utils_format_time__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(508);
/* harmony import */ var lib_utils_clipboard__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8215);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3887);
/* harmony import */ var cds_typography__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(506);
/* provided dependency */ var process = __webpack_require__(3454);





// components









// slices

// hooks




// utils


// styles


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  padding: 24px 16px;\n\n  ",
        " {\n    padding: 48px 72px 64px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: -64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0 24px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: 8px;\n  margin-bottom: 16px;\n  color: ",
        ";\n  ",
        ";\n  font-size: 24px;\n\n  ",
        " {\n    font-size: 32px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 8px 16px;\n  justify-content: space-between;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 12px;\n  cursor: pointer;\n\n  & strong {\n    padding-right: 12px;\n  }\n\n  & > span {\n    text-align: left;\n  }\n\n  & svg {\n    margin-left: 16px;\n    fill: ",
        ";\n    transform: ",
        ";\n    transform-origin: center;\n  }\n\n  ",
        " {\n    padding: 12px 20px;\n    font-size: 14px;\n  }\n\n  & ~ & {\n    margin-top: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  padding: 24px 16px;\n  ",
        ";\n  transition: 0.3s ease;\n  overflow: hidden;\n  & > p {\n    color: ",
        ";\n    margin-bottom: 16px;\n  }\n\n  * {\n    color: ",
        " !important;\n  }\n\n  a {\n    &:hover {\n      text-decoration: underline !important;\n    }\n  }\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  width: 140px;\n  padding: 0 8px;\n  margin: 16px 0 0 auto;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
/** 공지사항 페이지 */ var NoticePage = function() {
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_16__/* .useDispatch */ .I)();
    var noticeList = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_16__/* .useSelector */ .v)(function(state) {
        return state.service.noticeList;
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var enableMoreData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(true);
    var page = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(1);
    var target = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var MetaTitle = (0,hooks_common_useMetaData__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)().MetaTitle;
    (0,hooks_common_useInfiniteScroll__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        target: target,
        onIntersect: function(param) {
            var _param = _slicedToArray(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                onLoadData();
            }
        }
    });
    var onLoadData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, res;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (enableMoreData.current) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    setIsLoading(true);
                    enableMoreData.current = false;
                    _ctx.next = 7;
                    return dispatch((0,slices_service_thunk__WEBPACK_IMPORTED_MODULE_13__/* .getNoticeList */ .v)(page.current));
                case 7:
                    res = _ctx.sent;
                    setIsLoading(false);
                    if ((ref = res.list) === null || ref === void 0 ? void 0 : ref.length) {
                        page.current += 1;
                        enableMoreData.current = true;
                    }
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return onLoadData();
    }, [
        onLoadData
    ]);
    /** 공지사항 리스트 만들어주는 함수 */ var NoticeItem = function(param) {
        var notice = param.notice;
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
        var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isCopy = ref2[0], setIsCopy = ref2[1];
        var onClick = function(e) {
            var content = e.target.nextSibling;
            if (isOpen) {
                content.style.display = '';
            } else {
                content.style.display = 'block';
            }
            setIsOpen(function(v) {
                return !v;
            });
        };
        var onCopy = function() {
            var isTest = process.env.NEXT_PUBLIC_TEST === 'true';
            var host = isTest ? process.env.NEXT_PUBLIC_TEST_HOST : "https://www.classu.co.kr";
            (0,lib_utils_clipboard__WEBPACK_IMPORTED_MODULE_18__/* .copyToClipboard */ .v)("".concat(host, "/new/notice/").concat(notice.id));
            setIsCopy(true);
        };
        var Content = function() {
            return {
                __html: notice.content
            };
        };
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropdownItem, {
                    color: cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey010 */ .DG.grey010,
                    size: "Large",
                    onClick: onClick,
                    selected: isOpen,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: notice.subject
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            name: "ic_arrow_down_r",
                            width: 24,
                            height: 24,
                            fill: cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey0 */ .DG.grey0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropdownContent, {
                    selected: isOpen,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            children: (0,lib_utils_format_time__WEBPACK_IMPORTED_MODULE_21__/* .stringTimeFormatter */ .Q0)(notice.created_at)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            dangerouslySetInnerHTML: Content()
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ShareButton, {
                            size: "Small",
                            color: cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.BTN.BG */ .DG.BTN.BG,
                            isCopy: isCopy,
                            onClick: onCopy,
                            children: [
                                !isCopy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            name: "ic_copy",
                                            width: 18,
                                            height: 18,
                                            fill: cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey50 */ .DG.grey50
                                        }),
                                        "링크 복사하기"
                                    ]
                                }),
                                isCopy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: "링크 복사 완료!"
                                })
                            ]
                        })
                    ]
                })
            ]
        }));
    };
    var NoticeList = noticeList.map(function(v, idx) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NoticeItem, {
            notice: v
        }, idx);
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MetaTitle, {
                content: "공지사항"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(cds_layout_VerticalScroll__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                                children: "공지사항"
                            }),
                            NoticeList,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                ref: target
                            })
                        ]
                    }),
                    isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingLayout, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_atoms_common_SpinLoading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                    })
                ]
            })
        ]
    }));
};
var Header = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onCloseWebView = (0,hooks_bridge_useCommonBridge__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)().onCloseWebView;
    var onBack = function() {
        if (!onCloseWebView()) {
            router.back();
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_layout_headers_Both__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        message: "공지사항",
        leftSide: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            width: 24,
            height: 54,
            onClick: onBack,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                name: "ic_back_m",
                width: 24,
                height: 24,
                stroke: cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey75 */ .DG.grey75,
                fill: cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey75 */ .DG.grey75
            })
        })
    }));
};
NoticePage.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        mobileHeader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Header, {}),
        children: page
    }));
};
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(cds_layout_Main__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8102e88d-0"
})(_templateObject(), cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .mediaValue.large */ .T8.large, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .mediaQuery.large */ .cy.large);
var LoadingLayout = styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8102e88d-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-8102e88d-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey75 */ .DG.grey75, cds_typography__WEBPACK_IMPORTED_MODULE_20__/* .h1_medium */ .PN, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .mediaQuery.large */ .cy.large);
var DropdownItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8102e88d-3"
})(_templateObject3(), function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey0 */ .DG.grey0 : cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.BTN.BG */ .DG.BTN.BG;
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey50 */ .DG.grey50;
}, function(param) {
    var selected = param.selected;
    return selected ? cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.white */ .DG.white : cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey50 */ .DG.grey50;
}, function(param) {
    var selected = param.selected;
    return selected ? "rotate(180deg)" : "rotate(0)";
}, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .mediaQuery.large */ .cy.large);
var DropdownContent = styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8102e88d-4"
})(_templateObject4(), cds_typography__WEBPACK_IMPORTED_MODULE_20__/* .body3_regular */ .PD, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey040 */ .DG.grey040, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey50 */ .DG.grey50);
var ShareButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP)(cds_buttons_Outline__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8102e88d-5"
})(_templateObject5(), function(param) {
    var isCopy = param.isCopy;
    return isCopy ? cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.Primary.Active */ .DG.Primary.Active : cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.BTN.BG */ .DG.BTN.BG;
}, function(param) {
    var isCopy = param.isCopy;
    return isCopy ? cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.white */ .DG.white : cds_styles__WEBPACK_IMPORTED_MODULE_19__/* .palette.grey50 */ .DG.grey50;
});
/* harmony default export */ __webpack_exports__["default"] = (NoticePage);


/***/ }),

/***/ 3496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Both; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/components/atoms/messages/header/Title.js


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 헤더 타이틀
 * @param {object} props
 * @param {string} props.message
 */ var HeaderTitleMessage = function(param) {
    var message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
        children: message
    }));
};
var Message = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f2958021-0"
})(_templateObject(), styles/* palette.grey75 */.DG.grey75);
/* harmony default export */ var Title = (HeaderTitleMessage);

// EXTERNAL MODULE: ./src/components/layout/headers/Base.js
var Base = __webpack_require__(6332);
;// CONCATENATED MODULE: ./src/components/layout/headers/Both.js


// components


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Both_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Both_templateObject() {
    var data = Both_taggedTemplateLiteral([
        "\n  border-bottom: ",
        ";\n\n  ",
        " {\n    height: 84px;\n    border-bottom: ",
        ";\n  }\n"
    ]);
    Both_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = Both_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  max-width: 100%;\n  width: ",
        "px;\n  height: 100%;\n  padding: 0 16px;\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Both_taggedTemplateLiteral([
        "\n  flex-basis: 50%;\n  width: 50px;\n\n  &:first-child {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  &:last-child {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
/**
 * 좌/우 컨텐츠 존재 헤더
 * @param {object} props
 * @param {string} props.message
 * @param {import('react').ReactNode} props.leftSide
 * @param {import('react').ReactNode} props.rightSide
 * @param {import('react').ReactNode} props.centerSide
 * @param {boolean} props.noBorderBottom
 */ var BothHeader = function(_param) {
    var message = _param.message, leftSide = _param.leftSide, centerSide = _param.centerSide, rightSide = _param.rightSide, noBorderBottom = _param.noBorderBottom, props = _objectWithoutProperties(_param, [
        "message",
        "leftSide",
        "centerSide",
        "rightSide",
        "noBorderBottom"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, _objectSpread({
                noBorderBottom: noBorderBottom
            }, props, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: leftSide
                        }),
                        centerSide && centerSide,
                        !centerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            message: message
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            children: rightSide
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Base/* HeaderBlank */.m, {})
        ]
    }));
};
var Header = (0,styled_components_browser_esm/* default */.ZP)(Base/* default */.Z).withConfig({
    componentId: "sc-77bcfba2-0"
})(Both_templateObject(), function(param) {
    var noBorderBottom = param.noBorderBottom;
    return noBorderBottom ? '' : "1px solid ".concat(styles/* palette.system.BNB */.DG.system.BNB);
}, styles/* mediaQuery.large */.cy.large, function(param) {
    var noBorderBottom = param.noBorderBottom;
    return noBorderBottom ? '' : "1px solid ".concat(styles/* palette.system.grey */.DG.system.grey);
});
var ContentLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77bcfba2-1"
})(_templateObject1(), styles/* mediaValue.medium */.T8.medium);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77bcfba2-2"
})(_templateObject2(), styles/* palette.grey50 */.DG.grey50);
/* harmony default export */ var Both = (BothHeader);


/***/ }),

/***/ 8215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * 클립보드 복사 함수
 * - https, http에 따른 navigator.clipboard 의 사용여부가 달라집니다.
 * @param {string} text
 * @param {Element} target
 */ var copyToClipboard = function(text) {
    var targetDOM = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.body;
    var onTextarea = function() {
        var input = document.createElement('input');
        input.style.position = 'fixed';
        input.style.left = '-999999px';
        input.style.top = '-999999px';
        input.value = text;
        targetDOM.appendChild(input);
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        targetDOM.removeChild(input);
        return true;
    };
    var onNavigator = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return navigator.clipboard.writeText(text).catch(onTextarea);
                    case 2:
                        return _ctx.abrupt("return", true);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onNavigator() {
            return _ref.apply(this, arguments);
        };
    }();
    return onNavigator();
};


/***/ }),

/***/ 7688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ postCheckCoupon; },
/* harmony export */   "v": function() { return /* binding */ getNoticeList; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5700);
/* harmony import */ var api_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5853);
/* harmony import */ var slices_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5025);


//api

// actions

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * @dispatch 적립금 쿠폰 매칭
 * @param {object} props
 * @param {number} props.couponNumber 쿠폰 번호
 */ var postCheckCoupon = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)('service/postCheckCoupon', function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
        var couponNumber, dispatch;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    couponNumber = param.couponNumber, dispatch = param1.dispatch;
                    return _ctx.abrupt("return", api_service__WEBPACK_IMPORTED_MODULE_1__/* .postCheckCoupon */ .w1({
                        couponNumber: couponNumber
                    }).then(function(res) {
                        dispatch(slices_service__WEBPACK_IMPORTED_MODULE_2__/* .updateCoupon */ .CG(res));
                        return res;
                    }).catch(function() {
                        return false;
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
/**
 * @dispatch 공지사항 추가
 * @param {object} props
 * @param {number} props.page 페이지 카운트
 */ var getNoticeList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)('service/getNoticeList', function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param2) {
        var _page, page, dispatch;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _page = param.page, page = _page === void 0 ? 1 : _page, dispatch = param2.dispatch;
                    return _ctx.abrupt("return", api_service__WEBPACK_IMPORTED_MODULE_1__/* .getNotice */ .uT(page).then(function(res) {
                        dispatch(slices_service__WEBPACK_IMPORTED_MODULE_2__/* .pushNoticeList */ .J_(res.list));
                        return res.list;
                    }).catch(function() {
                        return false;
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_, _2) {
        return _ref.apply(this, arguments);
    };
}());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2725,1223,5644,9809,9774,2888,179], function() { return __webpack_exec__(4100); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);